// utils/moveClicksLast.js
export default function moveClicksLast(array = []) {
  if (!Array.isArray(array) || array.length === 0) return array;

  // Find the index of the "clicks" item
  const index = array.findIndex(
    (item) => item.event_group_name?.toLowerCase() === "views"
  );
  if (index === -1 || index === array.length - 1) return array; // not found or already last

  // Create a shallow copy and move the "views" item to the end
  const newArray = [...array];
  const [clickItem] = newArray.splice(index, 1);
  newArray.push(clickItem);

  return newArray;
}
